// Последний известный экран смены — в localStorage. Приложение открыли без
// сети (или перезапустили в подвале) — курьер всё равно видит свои точки и меню.

import { useQuery } from '@tanstack/react-query';

import { getShift, type ActiveShift } from '@/services/courier';

const KEY = 'resstro-courier-shift:v1';

export function readShiftCache(): ActiveShift | null | undefined {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as { active: ActiveShift | null }).active : undefined;
  } catch {
    return undefined;
  }
}

export function writeShiftCache(active: ActiveShift | null): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ active }));
  } catch {
    /* ignore */
  }
}

export function clearShiftCache(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export const SHIFT_KEY = ['shift'] as const;

/** Активная смена: null — смены нет; undefined — ещё не знаем (первый запуск без сети). */
export function useActiveShift() {
  return useQuery({
    queryKey: SHIFT_KEY,
    queryFn: async () => {
      const { active } = await getShift();
      writeShiftCache(active);
      return active;
    },
    initialData: readShiftCache,
    initialDataUpdatedAt: 0,
    refetchInterval: 60_000,
  });
}
